import CodiceFiscale from 'codice-fiscale-js'
import map from 'lodash/map'
import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  customerUpdate,
  phaseChange,
  reroute,
  storeDumpItForce,
} from '../../../actions/Buy'
import {
  findomesticTabelleDominio,
  findomesticUpdateDati,
  postFindomesticDatiClienteV1,
} from '../../../actions/buy/Findomestic'
import { putClientiV1 } from '../../../actions/noleggia/Clienti'
import {
  getComuniNazioniV1,
  searchComuniV2Cittadinanza,
  searchComuniV2IdentityCardEmission,
  searchComuniV2LicenseEmission,
  searchComuniV2LuogoNascita,
  searchComuniV2PassportEmission,
  searchComuniV2Residenza,
} from '../../../actions/noleggia/Comuni'
import { FinancingSettingsHelper } from '../../../helpers/financing/settings'
import verify from '../../../modules/verify'
import {
  getSettoriPerProfessionistiARischio,
  residenzaPrecendenteRequired,
  showCostoAbitazione,
  showDataInizioAttivita,
  showDataScadenzaContratto,
  showDatiConiuge,
  showOccupazione,
  showPaeseDiAttivita,
  showProfessionistiRischio,
  showReddito,
  showScaricaPep,
  showSedeLavoro,
  showSettore,
  showSituazioneLavorativa,
} from '../../../utils/findomesticUtils'
import {
  getCodiceCastale,
  transformCittadinanzaDefaultValue,
  transformComuniCittadinanzaV2Result,
  transformComuniNazioniDefaultValue,
  transformComuniResidenzaV2Result,
  transformComuniV2Result,
  transformIdentityCardV2Result,
  transformLicenseV2Result,
  transformPassportV2Result,
} from '../../../utils/searchComuniUtils'
import PhoneInput from '../../Input/Phone'
import DocumentiHelperModal from '../../noleggia/dumb/DocumentiHelperModal'
import {
  CRITEO_EVENTS,
  EVENT_TYPES,
  triggerClickStreamEvent,
} from '../../triggerDataLayerEvent'
import BuyBigModal from '../dumb/BuyBigModal'
import BuyDataForm from '../dumb/BuyDataForm'
import BuyDateInput from '../dumb/BuyDateInput'
import BuyRadioInput from '../dumb/BuyRadioInput'
import BuySelectInput2 from '../dumb/BuySelectInput2'
import BuyTextInput from '../dumb/BuyTextInput'
import BuyTextInput2 from '../dumb/BuyTextInput2'
import {
  haGaranzia3Anni,
  mapfreAssistenzaStradale,
  mapfreCondizioniGeneraliContratto,
  mapfreInformativaDatiPersonali,
  mapfreProgrammaGaranzia,
} from '../utils'

class BuyDataFormFindomestic extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.section = 2
    this.state.toTop = false
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
    this.handleRadio = this.handleRadio.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.handleNext = this.handleNext.bind(this)
    this.handlePrev = this.handlePrev.bind(this)
    this.againstMap = this.againstMap.bind(this)
    this.validate = this.validate.bind(this)
    this.state.flagDomicilio = false
    this.state.flagResidenza = false

    this.refCivicoConsegna = React.createRef()
    this.refIndirizzoConsegna = React.createRef()

    this.getEnteRilascioDocumentoValues =
      this.getEnteRilascioDocumentoValues.bind(this)
    this.state.show_condizioni_generali_di_contratto_modal = false
    this.state.show_termini_di_utilizzo_modal = false
    this.state.cap_residenza = this.props.customer.cap_residenza || ''
    this.state.caps_residenza = this.props.customer.caps_residenza || []
    this.state.select_cap_residenza =
      this.props.customer.select_cap_residenza || false
    this.state.cap_domicilio = this.props.customer.cap_domicilio || ''
    this.state.caps_domicilio = this.props.customer.caps_domicilio || []
    this.state.select_cap_domicilio =
      this.props.customer.select_cap_domicilio || false
    this.state.dati_cliente_nome_error = ''
    this.state.dati_cliente_cognome_error = ''
    this.state.dati_cliente_phone_error = ''
    this.state.dati_cliente_email_error = ''
    this.state.dati_cliente_sesso_error = ''
    this.state.dati_cliente_data_di_nascita_findomestic_error = ''
    this.state.dati_cliente_comune_nascita_error = ''
    this.state.dati_cliente_codice_fiscale_error = ''
    this.state.dati_cliente_partita_iva_error = ''
    this.state.dati_cliente_citta_residenza_error = ''
    this.state.dati_cliente_cap_residenza_error = ''
    this.state.dati_cliente_indirizzo_residenza_error = ''
    this.state.dati_cliente_numero_civico_residenza_error = ''

    this.state.dati_cliente_citta_consegna_error = ''
    this.state.dati_cliente_cap_consegna_error = ''
    this.state.dati_cliente_indirizzo_consegna_error = ''
    this.state.dati_cliente_numero_civico_consegna_error = ''

    this.state.dati_cliente_domicilio_diverso_error = ''
    this.state.dati_cliente_condizioni_brumbrum_obbligatorie_error = ''
    this.state.dati_cliente_citta_domicilio_error = ''
    this.state.dati_cliente_cap_domicilio_error = ''
    this.state.dati_cliente_indirizzo_domicilio_error = ''
    this.state.dati_cliente_civico_domicilio_error = ''
    this.state.dati_cliente_cittadinanza_error = ''
    this.state.dati_findomestic_situazione_abitativa_error = ''
    this.state.dati_findomestic_stato_civile_error = ''
    this.state.dati_findomestic_situazione_lavorativa_error = ''
    this.state.dati_findomestic_occupazione_error = ''
    this.state.dati_findomestic_tipo_contratto_error = ''
    this.state.dati_findomestic_anzianita_error = ''
    this.state.dati_findomestic_nome_societa_error = ''
    this.state.dati_findomestic_anni_apertura_conto_error = ''
    this.state.dati_findomestic_iban_error = ''
    this.state.dati_findomestic_carica_privata_error = ''
    this.state.dati_findomestic_altre_fonti_switch_error = ''
    this.state.dati_findomestic_altre_fonti_reddito_error = ''
    this.state.dati_findomestic_carica_pubblica_switch_error = ''
    this.state.dati_findomestic_carica_pubblica_error = ''
    this.state.dati_findomestic_settore_error = ''
    this.state.dati_findomestic_professione_error = ''
    this.state.dati_findomestic_residente_dal_error = ''
    this.state.select_cap_precedente =
      this.props.findomestic.dati.select_cap_precedente || false
    this.state.cap_precedente =
      this.props.findomestic.dati.cap_precedente || null
    this.state.caps_precedente =
      this.props.findomestic.dati.caps_precedente || []
    this.state.caps_lavoro = this.props.findomestic.dati.caps_lavoro || []
    this.state.select_cap_lavoro =
      this.props.findomestic.dati.select_cap_lavoro || false
    this.state.cap_lavoro = this.props.findomestic.dati.cap_lavoro || ''
    this.state.dati_findomestic_comune_precedente_error = ''
    this.state.dati_findomestic_cap_precedente_error = ''
    this.state.dati_findomestic_indirizzo_precedente_error = ''
    this.state.dati_findomestic_civico_precedente_error = ''
    this.state.dati_findomestic_data_apertura_conto_error = ''
    this.state.dati_findomestic_flagQualita_error = ''
    this.state.dati_findomestic_flagPromozioni_error = ''
    this.state.dati_findomestic_flagSocietaTerze_error = ''
    this.state.dati_cliente_informativa_trattamento_dati_personali_garanzia_error =
      ''
    this.state.dati_findomestic_datore_lavoro_error = ''
    this.state.dati_findomestic_telefono_fisso_lavoro_error = ''
    this.state.dati_findomestic_comune_lavoro_error = ''
    this.state.dati_findomestic_cap_lavoro_error = ''
    this.state.dati_findomestic_indirizzo_lavoro_error = ''
    this.state.dati_findomestic_civico_lavoro_error = ''
    this.state.dati_findomestic_data_scadenza_contratto_error = ''
    this.state.dati_findomestic_data_inizio_attivita_error = ''

    this.state.dati_findomestic_coniuge_situazione_lavorativa_error = ''
    this.state.dati_findomestic_coniuge_settore_error = ''
    this.state.dati_findomestic_coniuge_occupazione_error = ''
    this.state.dati_findomestic_coniuge_occupazione_error = ''
    this.state.dati_findomestic_coniuge_data_inizio_attivita_error = ''
    this.state.dati_findomestic_coniuge_data_scadenza_contratto_error = ''
    this.state.dati_findomestic_coniuge_reddito_mensile_lavoro_error = ''
    this.state.dati_findomestic_costo_abitazione_error = ''
    this.state.dati_cliente_fatturazione_uguale_error = ''
    this.state.dati_cliente_cap_fatturazione_error = ''
    this.state.dati_cliente_indirizzo_fatturazione_error = ''
    this.state.dati_cliente_numero_civico_fatturazione_error = ''
    this.state.dati_cliente_ragione_sociale_error = ''
    this.state.caps_fatturazione = this.props.customer.caps_fatturazione || []
    this.state.cap_fatturazione = this.props.customer.cap_fatturazione || ''
    this.state.select_cap_fatturazione =
      this.props.customer.select_cap_fatturazione || false

    this.state.cap_consegna = this.props.customer.cap_consegna || ''
    this.state.caps_consegna = this.props.customer.caps_consegna || []
    this.state.select_cap_consegna =
      this.props.customer.select_cap_consegna || false

    this.state.dati_findomestic_paese_di_attivita_principale_error = ''
    this.state.dati_findomestic_seconda_cittadinanza_error = ''

    // BRUM-7336 aggiunta documento di identita'
    this.state.documento = this.props.customer.documento || ''
    this.state.dati_cliente_documento_error = ''
    this.state.dati_cliente_numero_documento_error = ''
    this.state.dati_cliente_ente_rilascio_documento_error = ''
    this.state.dati_cliente_data_rilascio_documento_error = ''
    this.state.dati_findomestic_numero_documento_retro_patente_error = ''

    // BRUM-6739
    this.state.dati_findomestic_reddito_mensile_lavoro_error = ''
    this.state.show_howto_reddito_modal = false

    this.state.financingSettingsHelper = new FinancingSettingsHelper(
      props.ui.sellout_settings_acquista?.finanziamento_settings,
      props.financements
    )
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
    this.handleSelect('cittadinanza')(
      this.props.customer.cittadinanza || {
        label: 'italiana',
        value: 'ITA|italiana',
      }
    )
    if (this.props.customer) {
      map(this.props.customer, (value, key) => {
        if (typeof value === 'string') {
          this.validate(`dati_cliente_${key}`, value)
        }
      })
    }
  }

  async componentDidMount() {
    this.props.phaseChange({ phase: 30, last: 20 })

    await this.props.getComuniNazioniV1()
    await this.props.findomesticTabelleDominio()

    if (
      this.state.financingSettingsHelper.isFinancingOnlyQuotation &&
      this.state.financingSettingsHelper.isPrivateEmployee
    ) {
      this.handleSelect(
        'situazione_lavorativa',
        this.props.findomesticUpdateDati
      )({ label: 'Dipendente Privato', value: 'Dipendente Privato' })
    }

    this.props.storeDumpItForce()
    triggerClickStreamEvent(
      CRITEO_EVENTS.BASKET_FUNNEL_PERSONAL_DATA,
      EVENT_TYPES.CRITEO,
      {
        email: this.props.customer.email,
        idAuto: this.props.product.id_auto,
        price: numeral(
          this.props.ordine.totale - this.props.ordine.acconti
        ).format('$ 0,0[.]00'),
      }
    )
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.error.display === true &&
      this.props.error.display === false
    ) {
      // l'utente ha chiuso il popup di errore
      this.handlePrev()
    }
  }

  cleanUpField(ref) {
    if (!ref || !ref.current) {
      return
    }

    ref.current.querySelector('input').value = ''
  }

  validate(
    label,
    value,
    findomesticHandler = null,
    requireAttention = false,
    showError = true
  ) {
    const v = verify(label, value, this.againstMap(label))
    const t = this
    if (showError) {
      const newState = {}
      if (v.is_required || !v.is_valid) {
        newState[`${label}_error`] = v.is_required
          ? ' is-required'
          : ' is-error'
      } else {
        newState[`${label}_error`] = ' is-ok'
      }
      Object.keys(v.updates.states).forEach(key => {
        newState[key] = v.updates.states[key]
      })
      Object.keys(v.updates.stores).forEach(key => {
        const updateHandler =
          findomesticHandler !== null
            ? findomesticHandler
            : t.props.customerUpdate
        if (typeof updateHandler === 'function') {
          updateHandler({
            [key]: v.updates.stores[key],
          })
        }
      })
      this.setState(newState, () => {
        if (
          requireAttention &&
          document.querySelectorAll('.is-error, .is-required').length > 0
        ) {
          animateScroll.scrollTo(
            document.querySelectorAll('.is-error, .is-required')[0].offsetTop -
              95,
            {
              smooth: true,
              dynamic: true,
            }
          )
        }
      })
    }
    return v
  }

  againstMap(label) {
    const t = this

    let against = {
      dati_cliente_data_rilascio_permesso_soggiorno: {
        dati_cliente_data_di_nascita:
          t.props.customer.data_di_nascita_findomestic,
      },
      dati_cliente_citta_residenza: {
        dati_cliente_caps_residenza: t.props.customer.caps_residenza || [],
      },
      dati_cliente_citta_domicilio: {
        dati_cliente_caps_domicilio: t.props.customer.caps_domicilio || [],
      },
      dati_cliente_codice_fiscale: {
        nome: t.props.customer.nome || '',
        cognome: t.props.customer.cognome || '',
        sesso: t.props.customer.sesso || '',
        data_di_nascita: t.props.customer.data_di_nascita_findomestic,
        paese_comune_di_nascita: t.props.customer.comune_nascita || '',
      },
      dati_findomestic_residente_dal: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_findomestic_comune_precedente: {
        dati_findomestic_caps_precedente:
          t.props.findomestic.dati.caps_precedente || [],
      },
      dati_findomestic_data_apertura_conto: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_findomestic_comune_lavoro: {
        dati_findomestic_caps_lavoro:
          t.props.findomestic.dati.caps_lavoro || [],
      },
      dati_findomestic_data_scadenza_contratto: {
        dati_ordine_id_finanziamento: t.props.ordine.id_finanziamento,
        dati_finanziamento: t.props.financements.default
          .concat([].concat([t.props.financements.custom]))
          .filter(n => n),
      },
      dati_findomestic_data_inizio_attivita: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_findomestic_coniuge_data_inizio_attivita: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_cliente_citta_fatturazione: {
        dati_cliente_caps_fatturazione:
          t.props.customer.caps_fatturazione || [],
      },
      dati_cliente_data_rilascio_documento: {
        dati_cliente_data_di_nascita: t.props.customer.data_di_nascita,
      },
      dati_cliente_numero_documento: {
        dati_cliente_documento: t.props.customer.documento || '',
      },
      dati_findomestic_numero_documento_retro_patente: {
        dati_cliente_documento: t.props.customer.documento || '',
      },
    }

    if (
      t.props.logistica.centro_convenzionato.tipologia_consegna ===
      'Consegna a casa'
    ) {
      against = {
        ...against,
        dati_cliente_citta_consegna: {
          dati_cliente_caps_consegna: t.props.customer.caps_consegna || [],
        },
      }

      this.state.dati_cliente_cap_consegna_error = ''
    }

    return against[label]
  }

  validationMapDatiPersonali() {
    const t = this
    let validationMap = {
      dati_cliente_nome: t.props.customer.nome || '',
      dati_cliente_cognome: t.props.customer.cognome || '',
      dati_cliente_data_di_nascita_findomestic:
        t.props.customer.data_di_nascita_findomestic.raw || '',
      dati_cliente_comune_nascita: t.props.customer.comune_nascita || '',
      dati_cliente_codice_fiscale: t.props.customer.codice_fiscale || '',
      dati_cliente_email: t.props.customer.email || '',
      dati_cliente_phone: t.props.customer.phone || '',
      dati_cliente_sesso: t.props.customer.sesso || '',
      dati_cliente_cittadinanza: t.props.customer.cittadinanza || '',
      dati_findomestic_seconda_cittadinanza:
        t.props.findomestic.dati.seconda_cittadinanza || '',
      dati_findomestic_stato_civile:
        t.props.findomestic.dati.stato_civile || '',
      dati_findomestic_politicamente_esposto:
        t.props.findomestic.politicamente_esposto || '0',
    }

    if (t.props.customer.partita_iva) {
      validationMap = {
        ...validationMap,
        dati_cliente_partita_iva: t.props.customer.partita_iva,
      }
    }

    if (this.isCittadinanzaExtraEu()) {
      validationMap = {
        ...validationMap,
        dati_cliente_tipo_permesso_soggiorno:
          t.props.customer.tipo_permesso_soggiorno || '',
      }

      if (t.props.customer.tipo_permesso_soggiorno === 'temporary') {
        validationMap = {
          ...validationMap,
          dati_cliente_data_rilascio_permesso_soggiorno:
            t.props.customer.data_rilascio_permesso_soggiorno.raw || '',
          dati_cliente_data_scadenza_permesso_soggiorno:
            t.props.customer.data_scadenza_permesso_soggiorno.raw || '',
        }
      }
    }

    if (t.props.customer.fatturazione_uguale === '0') {
      validationMap = {
        ...validationMap,
        dati_cliente_citta_fatturazione:
          t.props.customer.citta_fatturazione || '',
        dati_cliente_cap_fatturazione:
          t.state.cap_fatturazione || t.props.customer.cap_fatturazione || '',
        dati_cliente_indirizzo_fatturazione:
          t.props.customer.indirizzo_fatturazione || '',
        dati_cliente_numero_civico_fatturazione:
          t.props.customer.numero_civico_fatturazione || '',
        dati_cliente_ragione_sociale: t.props.customer.ragione_sociale || '',
      }
    }

    return validationMap
  }

  validationMapResidenzaDomicilio() {
    const t = this
    let validationMap = {
      dati_cliente_citta_residenza: t.props.customer.citta_residenza || '',
      dati_cliente_cap_residenza:
        t.state.cap_residenza || t.props.customer.cap_residenza || '',
      dati_cliente_indirizzo_residenza:
        t.props.customer.indirizzo_residenza || '',
      dati_cliente_numero_civico_residenza:
        t.props.customer.numero_civico_residenza || '',
      dati_cliente_domicilio_diverso:
        t.props.customer.domicilio_diverso === 1 ||
        t.props.customer.domicilio_diverso === '1'
          ? '1'
          : '0',
      dati_findomestic_situazione_abitativa:
        t.props.findomestic.dati.situazione_abitativa || '',
      dati_findomestic_residente_dal:
        t.props.findomestic.dati.residente_dal.raw || '',
    }

    if (
      t.props.logistica.centro_convenzionato.tipologia_consegna ===
      'Consegna a casa'
    ) {
      validationMap = {
        ...validationMap,
        dati_cliente_citta_consegna: t.props.customer.citta_consegna || '',
        dati_cliente_cap_consegna:
          t.state.cap_consegna || t.props.customer.cap_consegna || '',
        dati_cliente_indirizzo_consegna:
          t.props.customer.indirizzo_consegna || '',
        dati_cliente_numero_civico_consegna:
          t.props.customer.numero_civico_consegna || '',
      }
    }

    if (
      t.props.customer.domicilio_diverso === '1' ||
      t.props.customer.domicilio_diverso === 1
    ) {
      validationMap = {
        ...validationMap,
        dati_cliente_citta_domicilio: t.props.customer.citta_domicilio || '',
        dati_cliente_cap_domicilio:
          t.state.cap_domicilio || t.props.customer.cap_domicilio || '',
        dati_cliente_indirizzo_domicilio:
          t.props.customer.indirizzo_domicilio || '',
        dati_cliente_civico_domicilio: t.props.customer.civico_domicilio || '',
      }
    }

    if (residenzaPrecendenteRequired(t.props.findomestic.dati)) {
      validationMap = {
        ...validationMap,
        dati_findomestic_comune_precedente:
          t.props.findomestic.dati.comune_precedente || '',
        dati_findomestic_cap_precedente:
          t.state.cap_precedente ||
          t.props.findomestic.dati.cap_precedente ||
          '',
        dati_findomestic_indirizzo_precedente:
          t.props.findomestic.dati.indirizzo_precedente || '',
        dati_findomestic_civico_precedente:
          t.props.findomestic.dati.civico_precedente || '',
      }
    }

    if (showCostoAbitazione(t.props.findomestic.dati)) {
      validationMap = {
        ...validationMap,
        dati_findomestic_costo_abitazione:
          t.props.findomestic.dati.costo_abitazione || '',
      }
    }

    return validationMap
  }

  validationMapLavoro() {
    const t = this

    const validationMap = {
      dati_findomestic_situazione_lavorativa:
        t.props.findomestic.dati.situazione_lavorativa || '',
      dati_cliente_documento: t.props.customer.documento || '',
      dati_cliente_numero_documento: t.props.customer.numero_documento || '',
      dati_cliente_ente_rilascio_documento:
        t.props.customer.ente_rilascio_documento || '',
      dati_cliente_data_rilascio_documento:
        t.props.customer.data_rilascio_documento.raw || '',
      dati_findomestic_numero_documento_retro_patente:
        t.props.findomestic.dati.numero_documento_retro_patente || '',
    }

    if (showOccupazione(t.props.findomestic)) {
      validationMap.dati_findomestic_occupazione =
        t.props.findomestic.dati.occupazione || ''
    }

    if (showSettore(t.props.findomestic)) {
      validationMap.dati_findomestic_settore =
        t.props.findomestic.dati.settore || ''
    }

    if (showSedeLavoro(t.props.findomestic)) {
      validationMap.dati_findomestic_datore_lavoro =
        t.props.findomestic.dati.datore_lavoro || ''
      validationMap.dati_findomestic_telefono_fisso_lavoro =
        t.props.findomestic.dati.telefono_fisso_lavoro || ''
      validationMap.dati_findomestic_comune_lavoro =
        t.props.findomestic.dati.comune_lavoro || ''
      validationMap.dati_findomestic_cap_lavoro =
        t.state.cap_lavoro || t.props.findomestic.dati.cap_lavoro || ''
      validationMap.dati_findomestic_indirizzo_lavoro =
        t.props.findomestic.dati.indirizzo_lavoro || ''
      validationMap.dati_findomestic_civico_lavoro =
        t.props.findomestic.dati.civico_lavoro || ''
    }

    if (showReddito(t.props.findomestic)) {
      validationMap.dati_findomestic_reddito_mensile_lavoro =
        t.props.findomestic.dati.reddito_mensile_lavoro || ''
    }

    if (showDataScadenzaContratto(t.props.findomestic)) {
      validationMap.dati_findomestic_data_scadenza_contratto =
        t.props.findomestic.dati.data_scadenza_contratto.raw || ''
    }

    if (showDataInizioAttivita(t.props.findomestic)) {
      validationMap.dati_findomestic_data_inizio_attivita =
        t.props.findomestic.dati.data_inizio_attivita.raw || ''
    }

    if (showDatiConiuge(t.props.findomestic)) {
      validationMap.dati_findomestic_coniuge_situazione_lavorativa =
        t.props.findomestic.dati.coniuge_situazione_lavorativa || ''

      if (showReddito(t.props.findomestic, true)) {
        validationMap.dati_findomestic_coniuge_reddito_mensile_lavoro =
          t.props.findomestic.dati.coniuge_reddito_mensile_lavoro || ''
      }

      if (showOccupazione(t.props.findomestic, true)) {
        validationMap.dati_findomestic_coniuge_occupazione =
          t.props.findomestic.dati.coniuge_occupazione || ''
      }

      if (showSettore(t.props.findomestic, true)) {
        validationMap.dati_findomestic_coniuge_settore =
          t.props.findomestic.dati.coniuge_settore || ''
      }

      if (showDataScadenzaContratto(t.props.findomestic, true)) {
        validationMap.dati_findomestic_coniuge_data_scadenza_contratto =
          t.props.findomestic.dati.coniuge_data_scadenza_contratto.raw || ''
      }

      if (showDataInizioAttivita(t.props.findomestic, true)) {
        validationMap.dati_findomestic_coniuge_data_inizio_attivita =
          t.props.findomestic.dati.coniuge_data_inizio_attivita.raw || ''
      }
    }

    if (showPaeseDiAttivita(t.props.findomestic.dati)) {
      validationMap.dati_findomestic_paese_di_attivita_principale =
        t.props.findomestic.dati.paese_di_attivita_principale || ''
    }

    if (showProfessionistiRischio(t.props.findomestic)) {
      validationMap.dati_findomestic_settore_rischio_aml =
        t.props.findomestic.dati.settore_rischio_aml || ''
    }

    if (
      showDatiConiuge(t.props.findomestic) &&
      showProfessionistiRischio(t.props.findomestic, true)
    ) {
      validationMap.dati_findomestic_coniuge_settore_rischio_aml =
        t.props.findomestic.dati.coniuge_settore_rischio_aml || ''
    }

    return validationMap
  }

  validationMapContoCorrente() {
    const t = this

    const validationMap = {
      dati_findomestic_data_apertura_conto:
        t.props.findomestic.dati.data_apertura_conto.raw || '',
      dati_findomestic_iban: t.props.findomestic.dati.iban || '',
    }
    return validationMap
  }

  validationMapPrivacy() {
    const t = this

    const findomesticDati = t.props.findomestic.dati

    const validationMap = {
      dati_findomestic_flagQualita: findomesticDati.flagQualita,
      dati_findomestic_flagSocietaTerze: findomesticDati.flagSocietaTerze,
      dati_findomestic_flagPromozioni: findomesticDati.flagPromozioni,
      dati_cliente_condizioni_brumbrum_obbligatorie:
        t.props.customer.condizioni_brumbrum_obbligatorie || '',
    }

    if (haGaranzia3Anni(t.props.garanzia)) {
      // eslint-disable-next-line max-len
      validationMap.dati_cliente_informativa_trattamento_dati_personali_garanzia =
        t.props.customer.informativa_trattamento_dati_personali_garanzia || ''
    }

    return validationMap
  }

  handlePrev() {
    this.setState({ section: this.state.section - 1 })
    animateScroll.scrollToTop()
  }

  handleNext(sezione) {
    const t = this
    return () => {
      let validationMap = {}

      switch (sezione) {
        case 'dati_personali':
        case 'residenza_e_domicilio':
          validationMap = t.validationMapDatiPersonali()
          validationMap = {
            ...validationMap,
            ...t.validationMapResidenzaDomicilio(),
          }
          break
        case 'privacy':
        case 'lavoro':
        case 'conto_corrente':
          validationMap = t.validationMapLavoro()
          validationMap = {
            ...validationMap,
            ...t.validationMapContoCorrente(),
            ...t.validationMapPrivacy(),
          }
          break
        default:
          break
      }

      const validationResults = Object.keys(validationMap).map(key => {
        const isValid = t.validate(key, validationMap[key], null, true).is_valid
        return isValid
      })

      if (
        validationResults.length > 0 &&
        validationResults.indexOf(false) === -1
      ) {
        t.setState({ section: t.state.section + 1 })
        animateScroll.scrollToTop()
        t.props.storeDumpItForce()
        if (sezione === 'privacy') {
          t.handleSubmit()
        }
      }
    }
  }

  handleInput(label, findomesticHandler = null) {
    const t = this
    return event => {
      const validateLabelPrefix =
        findomesticHandler !== null ? 'dati_findomestic_' : 'dati_cliente_'
      const v = t.validate(
        validateLabelPrefix + label,
        event.target ? event.target.value : event.value,
        findomesticHandler
      )

      const updateHandler =
        findomesticHandler !== null
          ? findomesticHandler
          : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale(updateHandler, validateLabelPrefix, {
        [validateLabelPrefix + label]: v.value,
      })
    }
  }

  handleSelect(label, findomesticHandler = null) {
    const t = this
    return selected => {
      const validateLabelPrefix =
        findomesticHandler !== null ? 'dati_findomestic_' : 'dati_cliente_'
      const v = t.validate(
        validateLabelPrefix + label,
        selected ? selected.value : '',
        findomesticHandler
      )

      const updateHandler =
        findomesticHandler !== null
          ? findomesticHandler
          : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
      t.autoFillCodiceFiscale(updateHandler, validateLabelPrefix, {
        [validateLabelPrefix + label]: v.value,
      })

      if (label === 'cittadinanza') {
        updateHandler({
          permesso_soggiorno: this.isCittadinanzaExtraEu(v.value),
        })
      }
    }
  }

  handleRadio(label, findomesticHandler = null) {
    const t = this
    return event => {
      const validateLabelPrefix =
        findomesticHandler !== null ? 'dati_findomestic_' : 'dati_cliente_'
      const v = t.validate(
        validateLabelPrefix + label,
        event.target.value,
        findomesticHandler
      )

      const updateHandler =
        findomesticHandler !== null
          ? findomesticHandler
          : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })

      if (label === 'documento') {
        t.setState({ [label]: v.value })
      }
    }
  }

  handleCheckbox(label, findomesticHandler = null) {
    const t = this
    return event => {
      const validateLabelPrefix =
        findomesticHandler !== null ? 'dati_findomestic_' : 'dati_cliente_'

      const v = t.validate(
        validateLabelPrefix + label,
        event.target.checked,
        findomesticHandler
      )

      const updateHandler =
        findomesticHandler !== null
          ? findomesticHandler
          : t.props.customerUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  handleSubmit() {
    this.props.putClientiV1().then(() => {
      this.props.postFindomesticDatiClienteV1().then(() => {
        this.props.reroute('/riepilogo-finanziamento-findomestic')
      })
    })
  }

  isCittadinanzaExtraEu(cittadinanzaValue = '') {
    const cittadinanza = cittadinanzaValue || this.props.customer.cittadinanza
    const codiceCittadinanza = cittadinanza ? cittadinanza.split('|')[0] : ''
    const codiceSecondaCittadinanza = this.props.findomestic.dati
      .seconda_cittadinanza
      ? this.props.findomestic.dati.seconda_cittadinanza.split('|')[0]
      : ''
    const cittadinanzaIsExtraEuByCodice =
      this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice
    const _isCittadinanzaExtraEu = cittadinanzaIsExtraEuByCodice[
      codiceCittadinanza
    ]
      ? !codiceSecondaCittadinanza ||
        cittadinanzaIsExtraEuByCodice[codiceSecondaCittadinanza]
      : false
    return _isCittadinanzaExtraEu || codiceCittadinanza !== 'ITA'
  }

  autoFillCodiceFiscale(updateAction, dataPrefix, newData) {
    let validation_map = {}
    validation_map[`${dataPrefix}nome`] = this.props.customer.nome || ''
    validation_map[`${dataPrefix}cognome`] = this.props.customer.cognome || ''
    validation_map[`${dataPrefix}sesso`] = this.props.customer.sesso || ''
    validation_map[`${dataPrefix}data_di_nascita_findomestic`] =
      this.props.customer.data_di_nascita_findomestic.raw || ''
    validation_map[`${dataPrefix}comune_nascita`] =
      this.props.customer.comune_nascita || ''
    if (newData[`${dataPrefix}data_di_nascita_findomestic`]) {
      newData[`${dataPrefix}data_di_nascita_findomestic`] =
        newData[`${dataPrefix}data_di_nascita_findomestic`].raw
    }
    validation_map = { ...validation_map, ...newData }
    const validation_results = Object.keys(validation_map).map(
      key =>
        this.validate(key, validation_map[key], false, false, false).is_valid
    )

    if (
      validation_results.length > 0 &&
      validation_results.indexOf(false) === -1
    ) {
      const birthplace = getCodiceCastale(
        validation_map.dati_cliente_comune_nascita
      )
      const cf = new CodiceFiscale({
        name: validation_map.dati_cliente_nome,
        surname: validation_map.dati_cliente_cognome,
        gender: validation_map.dati_cliente_sesso,
        day: validation_map.dati_cliente_data_di_nascita_findomestic.split(
          '/'
        )[0],
        month:
          validation_map.dati_cliente_data_di_nascita_findomestic.split('/')[1],
        year: validation_map.dati_cliente_data_di_nascita_findomestic.split(
          '/'
        )[2],
        birthplace,
      })
      updateAction({
        codice_fiscale: cf.code,
      })
      this.setState({
        calculated_codice_fiscale: cf.code,
        dati_cliente_codice_fiscale_error: ' is-ok',
      })
    }
  }

  getEnteRilascioDocumentoValues() {
    if (
      this.state.documento === 'Patente' &&
      this.props.comuni.searchLuogoEmissionePatente.length
    ) {
      return this.props.comuni.searchLuogoEmissionePatente
    }

    if (
      this.state.documento === 'Passaporto' &&
      this.props.comuni.searchLuogoEmissionePassaporto.length
    ) {
      return this.props.comuni.searchLuogoEmissionePassaporto
    }

    if (
      this.state.documento === 'CI' &&
      this.props.comuni.searchLuogoEmissioneCartaIdentita.length
    ) {
      return this.props.comuni.searchLuogoEmissioneCartaIdentita
    }

    return this.props.customer.ente_rilascio_documento
      ? [
          {
            label: this.props.customer.ente_rilascio_documento,
            value: this.props.customer.ente_rilascio_documento,
          },
        ]
      : []
  }

  render() {
    const { customer } = this.props
    const domicilioDiversoClasses =
      customer.domicilio_diverso === 1 || customer.domicilio_diverso === '1'
        ? 'wide'
        : 'wide hide'
    const domicilioDiversoThreeClasses =
      customer.domicilio_diverso === 1 || customer.domicilio_diverso === '1'
        ? 'three-t'
        : 'three-t hide'
    const domicilioDiversoTwoClasses =
      customer.domicilio_diverso === 1 || customer.domicilio_diverso === '1'
        ? 'two-t'
        : 'two-t hide'
    const findomesticPrivacyHref =
      'https://secure.findomestic.it/documenti/trasparenza/informativa-privacy-consumatori-prestito-personale-linea-di-credito-credito-finalizzato-credito-rotativo.pdf'

    const comuniNazioni = []
    if (this.props.comuni && this.props.comuni.comune) {
      comuniNazioni.push(
        ...this.props.comuni.comune.concat(this.props.comuni.nazione)
      )
    }

    const _residenzaPecedenteRequired = residenzaPrecendenteRequired(
      this.props.findomestic.dati
    )
    const residenzaPrecedenteClasses = _residenzaPecedenteRequired
      ? 'wide form-title'
      : 'wide form-title hide'
    const residenzaPrecedenteThreeClasses = _residenzaPecedenteRequired
      ? 'three-t form-title'
      : 'three-t form-title hide'
    const residenzaPrecedenteTwoClasses = _residenzaPecedenteRequired
      ? 'two-t form-title'
      : 'two-t form-title hide'

    return (
      <div>
        {this.state.section === 1 ||
          (this.state.section === 2 && (
            <div className={'next-steps __top_section'}>
              <h4>Tieni a portata di mano</h4>
              <ul>
                <li>
                  <i className={'icon-check-bold'} />
                  Documento di identità
                </li>
                <li>
                  <i className={'icon-check-bold'} />
                  Codice fiscale
                </li>
                <li>
                  <i className={'icon-check-bold'} />
                  Coordinate bancarie
                </li>
              </ul>
            </div>
          ))}
        <form className="form-passaggio findomestic">
          <BuyDataForm
            active={this.state.section === 1 || this.state.section === 2}
            icon="user"
            id={'dati_personali'}
            name="section-1"
            title="Dati Personali"
          >
            <li className={`${this.state.dati_cliente_nome_error} wide`}>
              <input
                className="form-input big capitalize"
                defaultValue={customer.nome || customer.name}
                label={'Nome conducente'}
                onBlur={this.handleInput('nome')}
                placeholder={'Scrivi il Nome'}
                type="text"
              />
              <label className="label">Nome</label>
              <div className="guide-tips">
                <span className="guide-tips-label">
                  Completo di secondo nome
                </span>
              </div>
            </li>
            <li className={`${this.state.dati_cliente_cognome_error} wide`}>
              <input
                className="form-input big capitalize"
                defaultValue={customer.cognome || customer.surname}
                label={'Cognome'}
                onBlur={this.handleInput('cognome')}
                placeholder={'Scrivi il Cognome'}
                type="text"
              />
              <label className="label">Cognome</label>
            </li>
            <li className={`${this.state.dati_cliente_email_error} wide`}>
              <input
                className="form-input big"
                defaultValue={customer.email}
                label={'Email'}
                onBlur={this.handleInput('email')}
                placeholder={'es: mario.rossi@gmail.com'}
                type="email"
              />
              <label className="label">Email</label>
            </li>
            <li className={`${this.state.dati_cliente_phone_error} wide`}>
              <PhoneInput
                onChange={this.handleInput('phone')}
                placeholder={'Scrivi il tuo Numero di cellulare'}
                value={customer.phone}
              />
            </li>
            <li className="hr" />
            <li className="wide">
              <label>Sesso</label>
            </li>
            <BuyRadioInput
              dataCyPrefix={'dataform-sesso-'}
              defaultValue={customer.sesso}
              label={'sesso '}
              liClassName={`${this.state.dati_cliente_sesso_error} wide`}
              spanClass="value small"
              update={this.handleRadio('sesso')}
              values={[
                { label: 'Femmina', value: 'F' },
                { label: 'Maschio', value: 'M' },
              ]}
            />
            <li className="hr" />
            <li
              className={`${this.state.dati_cliente_data_di_nascita_findomestic_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                dataCy={'dataform-date'}
                defaultValue={
                  this.props.customer.data_di_nascita_findomestic.raw || ''
                }
                label={'Data di nascita (gg/mm/aaaa)'}
                placeholder={'00/00/0000'}
                update={this.handleInput('data_di_nascita_findomestic')}
              />
              <div className="guide-tips">
                <span className="guide-tips-label">
                  Puoi finanziare solo se hai un etá compresa fra 18 e 75 anni
                </span>
              </div>
            </li>
            {this.props.comuni && this.props.comuni.comune ? (
              <BuySelectInput2
                async
                dataCy={'dataform-birth-town'}
                defaultOptions
                defaultValue={customer.comune_nascita}
                label="Comune di nascita (o Stato estero)"
                liClassName={`${this.state.dati_cliente_comune_nascita_error} wide`}
                loadOptions={searchQuery => {
                  const c = customer.comune_nascita
                    ? customer.comune_nascita.split('|')[0]
                    : ''
                  const sq = searchQuery || c
                  return this.props
                    .searchComuniV2LuogoNascita(sq)
                    .then(json => transformComuniV2Result(json.result))
                }}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect('comune_nascita')}
                values={
                  this.props.comuni.searchLuogoNascita.length
                    ? this.props.comuni.searchLuogoNascita
                    : [
                        transformComuniNazioniDefaultValue(
                          customer.comune_nascita
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}
            <li className="hr" />
            <li
              className={`${this.state.dati_cliente_codice_fiscale_error} wide`}
            >
              <BuyTextInput
                classes="form-input big uppercase"
                defaultValue={customer.codice_fiscale}
                label={'Codice Fiscale'}
                onInput={event =>
                  this.setState({
                    calculated_codice_fiscale: event.target.value,
                  })
                }
                placeholder={'Scrivi il tuo Codice fiscale'}
                type={'text'}
                update={this.handleInput('codice_fiscale')}
                value={this.state.calculated_codice_fiscale}
              />
            </li>
            <li className="hr" />
            <li className={`${this.state.dati_cliente_partita_iva_error} wide`}>
              <BuyTextInput
                classes="form-input big uppercase"
                defaultValue={customer.partita_iva}
                label={'Partita IVA (facoltativo)'}
                placeholder={'Scrivi la Partita IVA'}
                type={'text'}
                update={this.handleInput('partita_iva')}
              />
            </li>

            <li className="hr" />

            <BuySelectInput2
              async
              defaultOptions
              defaultValue={
                customer.cittadinanza || {
                  label: 'italiana',
                  value: 'ITA|italiana',
                }
              }
              label={'Cittadinanza'}
              liClassName={`${this.state.dati_cliente_cittadinanza_error} wide`}
              loadOptions={searchQuery => {
                const c = customer.cittadinanza
                  ? customer.cittadinanza.split('|')[1]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Cittadinanza(sq)
                  .then(
                    json =>
                      transformComuniCittadinanzaV2Result(json.result)
                        .cittadinanza
                  )
              }}
              placeholder={'Seleziona la Cittadinanza'}
              update={this.handleSelect('cittadinanza')}
              values={
                this.props.comuni.searchCittadinanza.length
                  ? this.props.comuni.searchCittadinanza.cittadinanza
                  : [
                      transformCittadinanzaDefaultValue(customer.cittadinanza),
                    ].filter(_ => _)
              }
            />

            <BuySelectInput2
              async
              defaultOptions
              defaultValue={this.props.findomestic.dati.seconda_cittadinanza}
              label={'Seconda cittadinanza (opzionale)'}
              liClassName={`${this.state.dati_findomestic_seconda_cittadinanza_error} wide`}
              loadOptions={searchQuery => {
                const c = this.props.findomestic.dati.seconda_cittadinanza
                  ? this.props.findomestic.dati.seconda_cittadinanza.split(
                      '|'
                    )[1]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Cittadinanza(sq)
                  .then(
                    json =>
                      transformComuniCittadinanzaV2Result(json.result)
                        .cittadinanza
                  )
              }}
              placeholder={'Seleziona la Seconda cittadinanza'}
              update={this.handleSelect(
                'seconda_cittadinanza',
                this.props.findomesticUpdateDati
              )}
              values={
                this.props.comuni.searchCittadinanza.length
                  ? this.props.comuni.searchCittadinanza.cittadinanza
                  : [
                      transformCittadinanzaDefaultValue(
                        this.props.findomestic.dati.seconda_cittadinanza
                      ),
                    ].filter(_ => _)
              }
            />

            {this.isCittadinanzaExtraEu() && ( // Tipo di permesso di soggiorno
              <li
                className={`${this.state.dati_cliente_tipo_permesso_soggiorno_error} wide`}
              >
                <BuySelectInput2
                  clearable={false}
                  defaultValue={this.props.customer.tipo_permesso_soggiorno}
                  label={'Permesso di soggiorno'}
                  name={'tipo_permesso_soggiorno'}
                  placeholder={'Permesso di soggiorno'}
                  update={this.handleSelect('tipo_permesso_soggiorno')}
                  values={[
                    {
                      label: 'Permesso con durata illimitata',
                      value: 'unlimited',
                    },
                    {
                      label: 'Permesso temporaneo o con data di scadenza',
                      value: 'temporary',
                    },
                  ]}
                />
              </li>
            )}

            {this.isCittadinanzaExtraEu() &&
              this.props.customer.tipo_permesso_soggiorno === 'temporary' && (
                <React.Fragment>
                  <li
                    className={`${this.state.dati_cliente_data_rilascio_permesso_soggiorno_error} wide`}
                  >
                    <BuyDateInput
                      classes="form-input big"
                      defaultValue={
                        this.props.customer.data_rilascio_permesso_soggiorno
                          .raw || ''
                      }
                      label={'Soggiorno dal (mm/aaaa)'}
                      mask="99/9999"
                      name={'dati_cliente_data_rilascio_permesso_soggiorno'}
                      placeholder={'00/0000'}
                      type={'text'}
                      update={this.handleInput(
                        'data_rilascio_permesso_soggiorno'
                      )}
                    />
                  </li>
                  <li
                    className={`${this.state.dati_cliente_data_scadenza_permesso_soggiorno_error} wide`}
                  >
                    <BuyDateInput
                      classes="form-input big"
                      defaultValue={
                        this.props.customer.data_scadenza_permesso_soggiorno
                          .raw || ''
                      }
                      label={'Data di scadenza permesso (gg/mm/aaaa)'}
                      name={'dati_cliente_data_scadenza_permesso_soggiorno'}
                      placeholder={'00/00/0000'}
                      type={'text'}
                      update={this.handleInput(
                        'data_scadenza_permesso_soggiorno'
                      )}
                    />
                  </li>
                </React.Fragment>
              )}

            <li className="hr" />

            <BuySelectInput2
              dataCy={'dataform-marital-status'}
              defaultValue={this.props.findomestic.dati.stato_civile}
              label={'Stato Civile'}
              liClassName={`${this.state.dati_findomestic_stato_civile_error} wide`}
              placeholder={'Seleziona lo stato civile'}
              update={this.handleSelect(
                'stato_civile',
                this.props.findomesticUpdateDati
              )}
              values={this.props.findomestic.CodiciStatoCivile}
            />

            <li className="hr" />

            <li className="wide form-title you-pep">
              <label>
                <a
                  href="https://files.brumbrum.it/definizione-di-persona-politicamente-esposta.pdf"
                  rel="noreferrer"
                  target="_blank"
                >
                  Sei una persona politicamente esposta?
                </a>
              </label>
            </li>
            <BuyRadioInput
              defaultValue={
                this.props.findomestic.dati.politicamente_esposto || '0'
              }
              label={'persona_politicamente_esposta '}
              liClassName={`${this.state.dati_findomestic_politicamente_esposto_error} wide you-pep`}
              update={this.handleRadio(
                'politicamente_esposto',
                this.props.findomesticUpdateDati
              )}
              values={[
                { label: 'No', value: '0' },
                { label: 'Si', value: '1' },
              ]}
            />
            {this.props.findomestic.dati.politicamente_esposto === '1' &&
            showScaricaPep(this.props.findomestic) ? (
              <li className="wide">
                <small>
                  <a
                    className="modal-btn"
                    data-modal="modulo-pep"
                    href="/assets/pdf/modulo-pep.pdf"
                    style={{ marginTop: '10px' }}
                    target="_blank"
                  >
                    <i
                      className="icon-upload"
                      style={{
                        fontSize: '17px',
                        position: 'relative',
                        top: '3px',
                      }}
                    ></i>
                    Scarica e compila questo modulo.
                  </a>
                </small>
              </li>
            ) : null}
          </BuyDataForm>
          <BuyDataForm
            active={this.state.section === 1 || this.state.section === 2}
            icon="home"
            id={'residenza_domicilio'}
            name="section-2"
            title="Residenza e domicilio"
          >
            <li className="hr" />
            <BuySelectInput2
              dataCy={'dataform-residence-type'}
              defaultValue={this.props.findomestic.dati.situazione_abitativa}
              label={'Situazione abitativa'}
              liClassName={`${this.state.dati_findomestic_situazione_abitativa_error} wide`}
              placeholder={'Seleziona la Situazione abitativa'}
              update={this.handleSelect(
                'situazione_abitativa',
                this.props.findomesticUpdateDati
              )}
              values={this.props.findomestic.CodiciAbitazione}
            />

            {showCostoAbitazione(this.props.findomestic.dati) ? (
              <li
                className={`${this.state.dati_findomestic_costo_abitazione_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={this.props.findomestic.dati.costo_abitazione}
                  isSymbol="input-symbol"
                  label={'Costo mensile abitazione'}
                  placeholder={'Scrivi il Costo mensile'}
                  theSymbol="€"
                  type={'number'}
                  update={this.handleInput(
                    'costo_abitazione',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {this.props.comuni && this.props.comuni.comune ? (
              <BuySelectInput2
                async
                dataCy={'dataform-residence-town'}
                defaultOptions
                defaultValue={customer.citta_residenza}
                label="Comune di residenza"
                liClassName={`${this.state.dati_cliente_citta_residenza_error} two-t`}
                loadOptions={searchQuery => {
                  const c = customer.citta_residenza
                    ? customer.citta_residenza.split('|')[0]
                    : ''
                  const sq = searchQuery || c
                  return this.props.searchComuniV2Residenza(sq).then(json => {
                    const { residenceProvince } =
                      this.state.financingSettingsHelper
                    const filteredResult =
                      this.state.financingSettingsHelper
                        .isFinancingOnlyQuotation && residenceProvince
                        ? json.result.filter(
                            municipality =>
                              residenceProvince ===
                              municipality.codice_provincia
                          )
                        : json.result

                    return transformComuniResidenzaV2Result(filteredResult)
                  })
                }}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect('citta_residenza')}
                values={
                  this.props.comuni.searchComuneResidenza.length
                    ? this.props.comuni.searchComuneResidenza
                    : [
                        transformComuniNazioniDefaultValue(
                          customer.citta_residenza
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}
            {this.state.select_cap_residenza && (
              <BuySelectInput2
                clearable={false}
                dataCy={'dataform-residence-cap'}
                defaultValue={customer.cap_residenza}
                label="Cap"
                liClassName={`${this.state.dati_cliente_cap_residenza_error} three-t`}
                placeholder={'Cap'}
                update={this.handleSelect('cap_residenza')}
                values={this.state.caps_residenza}
              />
            )}
            {!this.state.select_cap_residenza && (
              <li
                className={`${this.state.dati_cliente_cap_residenza_error} three-t`}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  dataCy={'dataform-residence-cap'}
                  disabled
                  label={'Cap'}
                  placeholder={'Scrivi il Cap'}
                  type={'number'}
                  update={this.handleInput('cap_residenza')}
                  value={customer.cap_residenza}
                />
              </li>
            )}
            <li
              className={`${this.state.dati_cliente_indirizzo_residenza_error} two-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                dataCy={'dataform-residence-address'}
                defaultValue={customer.indirizzo_residenza}
                label={'Indirizzo di residenza'}
                onInput={this.handleInput('indirizzo_residenza')}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_residenza')}
              />
            </li>
            <li
              className={`${this.state.dati_cliente_numero_civico_residenza_error} three-t`}
            >
              <BuyTextInput
                classes="input-data form-input big"
                dataCy={'dataform-residence-number'}
                defaultValue={customer.numero_civico_residenza}
                label={'Civico'}
                onInput={this.handleInput('numero_civico_residenza')}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('numero_civico_residenza')}
              />
            </li>

            <li className="hr" />

            <li
              className={`${this.state.dati_findomestic_residente_dal_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                dataCy={'dataform-residence-date'}
                defaultValue={
                  this.props.findomestic.dati.residente_dal.raw || ''
                }
                label={'Residente dal (mm/aaaa)'}
                mask="99/9999"
                placeholder={'00/0000'}
                type={'text'}
                update={this.handleInput(
                  'residente_dal',
                  this.props.findomesticUpdateDati
                )}
              />
            </li>

            <li className={residenzaPrecedenteClasses}>
              <label>Residenza precedente</label>
            </li>
            <BuySelectInput2
              async
              dataCy={'dataform-previous-residence-town'}
              defaultOptions
              defaultValue={this.props.findomestic.dati.comune_precedente}
              label={'Comune precedente'}
              liClassName={residenzaPrecedenteTwoClasses.concat(
                this.state.dati_findomestic_comune_precedente_error
              )}
              loadOptions={searchQuery => {
                const c = this.props.findomestic.dati.comune_precedente
                  ? this.props.findomestic.dati.comune_precedente.split('|')[0]
                  : ''
                const sq = searchQuery || c
                return this.props
                  .searchComuniV2Residenza(sq)
                  .then(json => transformComuniResidenzaV2Result(json.result))
              }}
              placeholder={'Seleziona il Comune'}
              update={this.handleSelect(
                'comune_precedente',
                this.props.findomesticUpdateDati
              )}
              values={
                this.props.comuni.searchComuneResidenza.length
                  ? this.props.comuni.searchComuneResidenza
                  : [
                      transformComuniNazioniDefaultValue(
                        this.props.findomestic.dati.comune_precedente
                      ),
                    ].filter(_ => _)
              }
            />
            {this.state.select_cap_precedente ? (
              <BuySelectInput2
                dataCy={'dataform-previous-residence-cap'}
                defaultValue={this.state.cap_precedente}
                label={'Cap'}
                liClassName={residenzaPrecedenteThreeClasses.concat(
                  this.state.dati_findomestic_cap_precedente_error
                )}
                placeholder={'Cap'}
                update={this.handleSelect(
                  'cap_precedente',
                  this.props.findomesticUpdateDati
                )}
                values={this.state.caps_precedente}
              />
            ) : null}
            {!this.state.select_cap_precedente ? (
              <li
                className={residenzaPrecedenteThreeClasses.concat(
                  this.state.dati_findomestic_cap_precedente_error
                )}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  dataCy={'dataform-previous-residence-cap'}
                  disabled
                  label={'Cap'}
                  placeholder={'Scrivi il Cap'}
                  type={'number'}
                  update={this.handleInput(
                    'cap_precedente',
                    this.props.findomesticUpdateDati
                  )}
                  value={this.state.cap_precedente}
                />
              </li>
            ) : null}
            <li
              className={residenzaPrecedenteTwoClasses.concat(
                this.state.dati_findomestic_indirizzo_precedente_error
              )}
            >
              <BuyTextInput
                classes="input-data form-input big capitalize"
                dataCy={'dataform-previous-residence-address'}
                defaultValue={this.props.findomestic.dati.indirizzo_precedente}
                label={'Indirizzo precedente'}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput(
                  'indirizzo_precedente',
                  this.props.findomesticUpdateDati
                )}
              />
            </li>
            <li
              className={residenzaPrecedenteThreeClasses.concat(
                this.state.dati_findomestic_civico_precedente_error
              )}
            >
              <BuyTextInput
                classes="input-data form-input big"
                dataCy={'dataform-previous-residence-number'}
                defaultValue={this.props.findomestic.dati.civico_precedente}
                label={'Civico'}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput(
                  'civico_precedente',
                  this.props.findomesticUpdateDati
                )}
              />
            </li>

            <li className="hr" />

            <li className="wide form-title">
              <label>I dati di fatturazione sono uguali alla residenza?</label>
            </li>
            <BuyRadioInput
              defaultValue={
                customer.fatturazione_uguale
                  ? `${customer.fatturazione_uguale}`
                  : '1'
              }
              label={'fatturazione_uguale'}
              liClassName={`${this.state.dati_cliente_fatturazione_uguale_error} wide`}
              update={this.handleRadio('fatturazione_uguale')}
              values={[
                { label: 'No', value: '0' },
                { label: 'Si', value: '1' },
              ]}
            />

            {customer.fatturazione_uguale === '0' ? (
              <li
                className={`${this.state.dati_cliente_ragione_sociale_error} wide`}
              >
                <BuyTextInput
                  classes="form-input big uppercase"
                  defaultValue={customer.ragione_sociale}
                  label={'Ragione sociale (facoltativa)'}
                  placeholder={'Scrivi la Ragione sociale'}
                  type={'text'}
                  update={this.handleInput('ragione_sociale')}
                />
              </li>
            ) : null}

            {customer.fatturazione_uguale === '0' ? (
              <BuySelectInput2
                async
                defaultOptions
                defaultValue={customer.citta_fatturazione}
                label="Comune di fatturazione"
                liClassName={`${this.state.dati_cliente_citta_fatturazione_error} two-t `}
                loadOptions={searchQuery => {
                  const c = customer.citta_fatturazione
                    ? customer.citta_fatturazione.split('|')[0]
                    : ''
                  const sq = searchQuery || c

                  return this.props
                    .searchComuniV2Residenza(sq)
                    .then(json => transformComuniResidenzaV2Result(json.result))
                }}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect('citta_fatturazione')}
                values={
                  this.props.comuni.searchComuneResidenza.length
                    ? this.props.comuni.searchComuneResidenza
                    : [
                        transformComuniNazioniDefaultValue(
                          customer.citta_fatturazione
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}

            {customer.fatturazione_uguale === '0' &&
            this.state.select_cap_fatturazione ? (
              <BuySelectInput2
                clearable={false}
                defaultValue={customer.cap_fatturazione}
                label={'Cap'}
                liClassName={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
                placeholder={'Cap'}
                update={this.handleSelect('cap_fatturazione')}
                values={this.state.caps_fatturazione}
              />
            ) : null}

            {customer.fatturazione_uguale === '0' &&
            !this.state.select_cap_fatturazione ? (
              <li
                className={`${this.state.dati_cliente_cap_fatturazione_error} three-t`}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  disabled
                  label={'Cap'}
                  placeholder={'Scrivi il Cap'}
                  type={'number'}
                  update={this.handleInput('cap_fatturazione')}
                  value={this.state.cap_fatturazione}
                />
              </li>
            ) : null}

            {customer.fatturazione_uguale === '0' ? (
              <li
                className={`${this.state.dati_cliente_indirizzo_fatturazione_error} two-t`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={customer.indirizzo_fatturazione}
                  label={'Indirizzo di fatturazione'}
                  placeholder={"Scrivi l'indirizzo"}
                  type={'text'}
                  update={this.handleInput('indirizzo_fatturazione')}
                />
              </li>
            ) : null}

            {customer.fatturazione_uguale === '0' ? (
              <li
                className={`${this.state.dati_cliente_numero_civico_fatturazione_error} three-t`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={customer.numero_civico_fatturazione}
                  label={'Civico'}
                  placeholder={'Civico'}
                  type={'text'}
                  update={this.handleInput('numero_civico_fatturazione')}
                />
              </li>
            ) : null}

            <li className="hr" />

            <li className="wide form-title">
              <label>Il domicilio è diverso dall’indirizzo di residenza?</label>
            </li>
            <BuyRadioInput
              defaultValue={
                customer.domicilio_diverso === 1 ||
                customer.domicilio_diverso === '1'
                  ? '1'
                  : '0'
              }
              label={'domicilio_diverso'}
              liClassName={`${this.state.dati_cliente_domicilio_diverso_error} wide`}
              update={this.handleRadio('domicilio_diverso')}
              values={[
                { label: 'No', value: '0' },
                { label: 'Si', value: '1' },
              ]}
            />

            <li className={`${domicilioDiversoClasses} hr`} />
            {this.props.comuni && this.props.comuni.comune ? (
              <BuySelectInput2
                async
                defaultOptions
                defaultValue={customer.citta_domicilio}
                label="Comune di domicilio"
                liClassName={domicilioDiversoTwoClasses.concat(
                  this.state.dati_cliente_citta_domicilio_error
                )}
                loadOptions={searchQuery => {
                  const c = customer.citta_domicilio
                    ? customer.citta_domicilio.split('|')[0]
                    : ''
                  const sq = searchQuery || c
                  return this.props
                    .searchComuniV2Residenza(sq)
                    .then(json => transformComuniResidenzaV2Result(json.result))
                }}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect('citta_domicilio')}
                values={
                  this.props.comuni.searchComuneResidenza.length
                    ? this.props.comuni.searchComuneResidenza
                    : [
                        transformComuniNazioniDefaultValue(
                          customer.citta_domicilio
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}
            {this.state.select_cap_domicilio && (
              <BuySelectInput2
                clearable={false}
                defaultValue={customer.cap_domicilio}
                label="Cap"
                liClassName={domicilioDiversoThreeClasses.concat(
                  this.state.dati_cliente_cap_domicilio_error
                )}
                placeholder={'Cap'}
                update={this.handleSelect('cap_domicilio')}
                values={this.state.caps_domicilio}
              />
            )}
            {!this.state.select_cap_domicilio && (
              <li
                className={domicilioDiversoThreeClasses.concat(
                  this.state.dati_cliente_cap_domicilio_error
                )}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  disabled
                  label={'Cap'}
                  placeholder={'Scrivi il Cap'}
                  type={'number'}
                  update={this.handleInput('cap_domicilio')}
                  value={customer.cap_domicilio}
                />
              </li>
            )}
            <li
              className={domicilioDiversoTwoClasses.concat(
                this.state.dati_cliente_indirizzo_domicilio_error
              )}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.indirizzo_domicilio}
                label={'Indirizzo di domicilio'}
                onInput={this.handleInput('indirizzo_domicilio')}
                placeholder={"Scrivi l'indirizzo"}
                type={'text'}
                update={this.handleInput('indirizzo_domicilio')}
              />
            </li>
            <li
              className={domicilioDiversoThreeClasses.concat(
                this.state.dati_cliente_civico_domicilio_error
              )}
            >
              <BuyTextInput
                classes="input-data form-input big"
                defaultValue={customer.civico_domicilio}
                label={'Civico'}
                onInput={this.handleInput('civico_domicilio')}
                placeholder={'Civico'}
                type={'text'}
                update={this.handleInput('civico_domicilio')}
              />
            </li>

            {/* scelta consegna */}

            <BuyDataForm
              active={
                this.props.logistica.centro_convenzionato.tipologia_consegna ===
                'Consegna a casa'
              }
              icon="home"
              id={'consegna_domicilio'}
              name="section-consegna-domicilio"
              title="Indirizzo per la consegna della tua auto"
            >
              {this.props.customer.citta_residenza &&
              this.props.customer.cap_residenza &&
              this.props.customer.indirizzo_residenza &&
              this.props.customer.numero_civico_residenza ? (
                <li style={{ margin: '0', width: '50%' }}>
                  <label
                    className="r-checkbox long"
                    data-cy="dataform-copy-from-residence"
                  >
                    <input
                      checked={this.state.flagResidenza}
                      name="flagResidenza"
                      onChange={() => {
                        this.setState(
                          prevState => ({
                            flagResidenza: !prevState.flagResidenza,
                          }),
                          () => {
                            if (this.state.flagResidenza) {
                              this.setState(
                                {
                                  flagDomicilio: false,
                                },
                                () => {
                                  this.handleSelect('citta_consegna')({
                                    value: this.props.customer.citta_residenza,
                                  })
                                  this.handleSelect('cap_consegna')({
                                    value: this.props.customer.cap_residenza,
                                  })
                                  this.handleInput('indirizzo_consegna')({
                                    value:
                                      this.props.customer.indirizzo_residenza,
                                  })
                                  this.handleInput('numero_civico_consegna')({
                                    value:
                                      this.props.customer
                                        .numero_civico_residenza,
                                  })
                                }
                              )
                            }

                            if (
                              !this.state.flagResidenza &&
                              !this.state.flagDomicilio
                            ) {
                              this.handleSelect('citta_consegna')({
                                value: '',
                              })
                              this.handleSelect('cap_consegna')({
                                value: '',
                              })
                              this.handleInput('indirizzo_consegna')({
                                value: ' ',
                              })
                              this.handleInput('numero_civico_consegna')({
                                value: ' ',
                              })

                              this.cleanUpField(this.refCivicoConsegna)
                              this.cleanUpField(this.refIndirizzoConsegna)
                            }
                          }
                        )
                      }}
                      type="checkbox"
                    />
                    <span className="check"></span>
                    Copia da residenza
                  </label>
                </li>
              ) : null}

              {this.props.customer.domicilio_diverso === '1' &&
              this.props.customer.citta_domicilio &&
              this.props.customer.cap_domicilio &&
              this.props.customer.indirizzo_domicilio &&
              this.props.customer.civico_domicilio ? (
                <li style={{ margin: '0', width: '50%' }}>
                  <label className="r-checkbox long">
                    <input
                      checked={this.state.flagDomicilio}
                      name="flagDomicilio"
                      onChange={() => {
                        this.setState(
                          prevState => ({
                            flagDomicilio: !prevState.flagDomicilio,
                          }),
                          () => {
                            if (this.state.flagDomicilio) {
                              this.setState(
                                {
                                  flagResidenza: false,
                                },
                                () => {
                                  this.handleSelect('citta_consegna')({
                                    value: this.props.customer.citta_domicilio,
                                  })
                                  this.handleSelect('cap_consegna')({
                                    value: this.props.customer.cap_domicilio,
                                  })
                                  this.handleInput('indirizzo_consegna')({
                                    value:
                                      this.props.customer.indirizzo_domicilio,
                                  })
                                  this.handleInput('numero_civico_consegna')({
                                    value: this.props.customer.civico_domicilio,
                                  })
                                }
                              )
                            }

                            if (
                              !this.state.flagResidenza &&
                              !this.state.flagDomicilio
                            ) {
                              this.handleSelect('citta_consegna')({
                                value: '',
                              })
                              this.handleSelect('cap_consegna')({
                                value: '',
                              })
                              this.handleInput('indirizzo_consegna')({
                                value: ' ',
                              })
                              this.handleInput('numero_civico_consegna')({
                                value: ' ',
                              })

                              this.cleanUpField(this.refCivicoConsegna)
                              this.cleanUpField(this.refIndirizzoConsegna)
                            }
                          }
                        )
                      }}
                      type="checkbox"
                    />
                    <span className="check"></span>
                    Copia da domicilio
                  </label>
                </li>
              ) : null}

              <li className="hr" style={{ margin: '20px 0' }} />

              {this.props.comuni &&
              this.props.comuni.comune &&
              !this.state.flagResidenza &&
              !this.state.flagDomicilio ? (
                <BuySelectInput2
                  async
                  defaultValue={customer.citta_consegna}
                  label="Comune di consegna"
                  liClassName={`${this.state.dati_cliente_citta_consegna_error} two-t`}
                  loadOptions={searchQuery => {
                    const c = customer.citta_consegna
                      ? customer.citta_consegna.split('|')[0]
                      : ''
                    const sq = searchQuery || c
                    return this.props
                      .searchComuniV2Residenza(sq)
                      .then(json =>
                        transformComuniResidenzaV2Result(json.result)
                      )
                  }}
                  name={'dati_cliente_citta_consegna'}
                  placeholder={'Seleziona il Comune'}
                  update={this.handleSelect('citta_consegna')}
                  values={
                    this.props.comuni.searchComuneResidenza.length
                      ? this.props.comuni.searchComuneResidenza
                      : [
                          transformComuniNazioniDefaultValue(
                            customer.citta_consegna
                          ),
                        ].filter(_ => _)
                  }
                />
              ) : null}

              {this.props.comuni &&
                this.props.comuni.comune &&
                (this.state.flagResidenza || this.state.flagDomicilio) && (
                  <li
                    className={`${this.state.dati_cliente_citta_consegna_error} two-t`}
                  >
                    <BuyTextInput2
                      classes="input-data form-input big"
                      defaultValue={customer.citta_consegna}
                      disabled
                      label="Comune di consegna"
                      name={'dati_cliente_citta_consegna'}
                      placeholder={'Seleziona il Comune'}
                      update={this.handleSelect('citta_consegna')}
                      value={
                        transformComuniNazioniDefaultValue(
                          customer.citta_consegna
                        ) &&
                        transformComuniNazioniDefaultValue(
                          customer.citta_consegna
                        ).label
                      }
                    />
                  </li>
                )}

              {this.state.select_cap_consegna && (
                <BuySelectInput2
                  defaultValue={customer.cap_consegna}
                  label="Cap"
                  liClassName={`${this.state.dati_cliente_cap_consegna_error} three-t`}
                  name={'dati_cliente_cap_consegna'}
                  placeholder={'Cap'}
                  update={this.handleSelect('cap_consegna')}
                  values={this.state.caps_consegna}
                />
              )}
              {!this.state.select_cap_consegna && (
                <li
                  className={`${this.state.dati_cliente_cap_consegna_error} three-t`}
                >
                  <BuyTextInput2
                    classes="input-data form-input big"
                    defaultValue={customer.cap_consegna}
                    disabled
                    label={'Cap'}
                    placeholder={'Cap'}
                    type={'number'}
                    update={this.handleInput('cap_consegna')}
                    value={customer.cap_consegna}
                  />
                </li>
              )}

              <li
                className={`two-t ${this.state.dati_cliente_indirizzo_consegna_error}`}
                ref={this.refIndirizzoConsegna}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={customer.indirizzo_consegna}
                  disabled={
                    this.state.flagDomicilio || this.state.flagResidenza
                  }
                  label={'Indirizzo di consegna'}
                  placeholder={"Scrivi l'indirizzo"}
                  type={'text'}
                  update={this.handleInput('indirizzo_consegna')}
                  value={
                    this.state.flagDomicilio || this.state.flagResidenza
                      ? customer.indirizzo_consegna
                      : null
                  }
                />
              </li>
              <li
                className={`three-t ${this.state.dati_cliente_numero_civico_consegna_error}`}
                ref={this.refCivicoConsegna}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={customer.numero_civico_consegna}
                  disabled={
                    this.state.flagDomicilio || this.state.flagResidenza
                  }
                  label={'Civico'}
                  placeholder={'Civico'}
                  type={'text'}
                  update={this.handleInput('numero_civico_consegna')}
                  value={
                    this.state.flagDomicilio || this.state.flagResidenza
                      ? customer.numero_civico_consegna
                      : null
                  }
                />
              </li>
            </BuyDataForm>

            <li className="hr" />

            <li className="wide buttons">
              <a
                className={`btn btn-primary js-next-step ${
                  this.props.fetching ? ' btn-disabled' : ''
                }`}
                data-cy="dataform-submit"
                onClick={this.handleNext('residenza_e_domicilio')}
              >
                <span>Prosegui</span>
              </a>
            </li>
          </BuyDataForm>

          <BuyDataForm
            active={this.state.section === 3}
            className={'no-margin-bottom'}
            id={'documento_identita'}
            liWideClass={'no-margin'}
            name="section-3"
            title="Documento di identità"
            titleClass={'no-margin no-padding'}
          >
            <li className="wide form-title no-margin">
              <label>Documento di riconoscimento</label>
            </li>

            <BuyRadioInput
              dataCyPrefix={'dataform-document-type-'}
              defaultValue={customer.documento}
              label={'documento '}
              liClassName={`${this.state.dati_cliente_documento_error} wide you-pep`}
              spanClass="value small"
              update={this.handleRadio('documento')}
              values={[
                { label: "Carta d'identità", value: 'CI' },
                { label: 'Passaporto', value: 'Passaporto' },
                { label: 'Patente', value: 'Patente' },
              ]}
            />

            {this.state.documento.length > 0 ? (
              <li
                className={`${this.state.dati_cliente_numero_documento_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big uppercase"
                  dataCy={'dataform-idcard-number'}
                  defaultValue={customer.numero_documento}
                  label={'Numero del documento'}
                  placeholder={'Scrivi il Numero del documento'}
                  type={'text'}
                  update={this.handleInput('numero_documento')}
                />
              </li>
            ) : null}
            {customer.documento === 'Patente' ? (
              <li
                className={`${this.state.dati_findomestic_numero_documento_retro_patente_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big uppercase"
                  dataCy={'dataform-license-number'}
                  defaultValue={
                    this.props.findomestic.dati.numero_documento_retro_patente
                  }
                  label={'Codice retro della patente (in basso a destra)'}
                  placeholder={'Scrivi il numero Della patente'}
                  type={'text'}
                  update={this.handleInput(
                    'numero_documento_retro_patente',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}
            {this.state.documento.length > 0 ? (
              <BuySelectInput2
                async
                dataCy={'dataform-document-issuer'}
                defaultOptions
                defaultValue={customer.ente_rilascio_documento}
                disabled={this.state.documento.length === 0}
                label={
                  this.state.documento === 'CI'
                    ? 'Rilasciato dal Comune di'
                    : this.state.documento === 'Passaporto'
                    ? 'Rilasciato dal Min. Affari Esteri/Questura di'
                    : this.state.documento === 'Patente'
                    ? 'Rilasciato dalla Prefettura/Mot. Civile di'
                    : 'Rilasciato da'
                }
                liClassName={`${this.state.dati_cliente_ente_rilascio_documento_error} wide`}
                loadOptions={searchQuery => {
                  const c = customer.ente_rilascio_documento
                    ? customer.ente_rilascio_documento.split('|')[0]
                    : ''

                  const sq = searchQuery || c

                  const searchFunc =
                    this.state.documento === 'Patente'
                      ? this.props.searchComuniV2LicenseEmission
                      : this.state.documento === 'Passaporto'
                      ? this.props.searchComuniV2PassportEmission
                      : this.state.documento === 'CI'
                      ? this.props.searchComuniV2IdentityCardEmission
                      : null

                  const transformFunc =
                    this.state.documento === 'Patente'
                      ? transformLicenseV2Result
                      : this.state.documento === 'Passaporto'
                      ? transformPassportV2Result
                      : this.state.documento === 'CI'
                      ? transformIdentityCardV2Result
                      : null

                  return searchFunc(sq).then(json => transformFunc(json.result))
                }}
                placeholder={'Seleziona il Comune di rilascio'}
                update={this.handleSelect('ente_rilascio_documento')}
                values={this.getEnteRilascioDocumentoValues()}
              />
            ) : null}
            {this.state.documento.length > 0 ? (
              <li
                className={`${this.state.dati_cliente_data_rilascio_documento_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  dataCy={'dataform-document-release-date'}
                  defaultValue={
                    this.props.customer.data_rilascio_documento.raw || ''
                  }
                  label={'Data di rilascio (gg/mm/aaaa)'}
                  placeholder={'00/00/0000'}
                  type={'text'}
                  update={this.handleInput('data_rilascio_documento')}
                />
              </li>
            ) : null}
          </BuyDataForm>

          <BuyDataForm
            active={this.state.section === 3}
            icon="work"
            id={'lavoro'}
            name="section-3"
            title="Situazione lavorativa"
          >
            {showSituazioneLavorativa(this.props.findomestic) &&
              (!this.state.financingSettingsHelper.isFinancingOnlyQuotation ||
                !this.state.financingSettingsHelper.isPrivateEmployee) && (
                <BuySelectInput2
                  dataCy={'dataform-job-type'}
                  defaultValue={
                    this.props.findomestic.dati.situazione_lavorativa
                  }
                  label={'Situazione lavorativa'}
                  liClassName={`${this.state.dati_findomestic_situazione_lavorativa_error} wide`}
                  placeholder={'Seleziona la Situazione lavorativa'}
                  update={this.handleSelect(
                    'situazione_lavorativa',
                    this.props.findomesticUpdateDati
                  )}
                  values={this.props.findomestic.situazioneLavorativa}
                />
              )}

            {showSituazioneLavorativa(this.props.findomestic) &&
            this.state.financingSettingsHelper.isFinancingOnlyQuotation &&
            this.state.financingSettingsHelper.isPrivateEmployee ? (
              <li
                className={`${this.state.dati_findomestic_situazione_lavorativa_error} wide`}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  dataCy={'dataform-job-type'}
                  defaultValue={
                    this.props.findomestic.dati.situazione_lavorativa
                  }
                  disabled
                  label="Situazione lavorativa"
                  name={'dati_findomestic_situazione_lavorativa'}
                  placeholder={'Seleziona la Situazione lavorativa'}
                  update={this.handleSelect(
                    'situazione_lavorativa',
                    this.props.findomesticUpdateDati
                  )}
                  value={this.props.findomestic.dati.situazione_lavorativa}
                />
              </li>
            ) : null}

            {showSettore(this.props.findomestic) ? (
              <BuySelectInput2
                dataCy={'dataform-job-sector'}
                defaultValue={this.props.findomestic.dati.settore}
                label={'Settore'}
                liClassName={`${this.state.dati_findomestic_settore_error} wide`}
                placeholder={'Seleziona il Settore'}
                update={this.handleSelect(
                  'settore',
                  this.props.findomesticUpdateDati
                )}
                values={
                  this.props.findomestic.settoreBySituazione[
                    this.props.findomestic.dati.situazione_lavorativa
                  ]
                }
              />
            ) : null}

            {showOccupazione(this.props.findomestic) ? (
              <BuySelectInput2
                dataCy={'dataform-job'}
                defaultValue={this.props.findomestic.dati.occupazione}
                label={"Occupazione/Attivita'"}
                liClassName={`${this.state.dati_findomestic_occupazione_error} wide`}
                placeholder={"Seleziona l'Occupazione/Attività"}
                update={this.handleSelect(
                  'occupazione',
                  this.props.findomesticUpdateDati
                )}
                values={
                  this.props.findomestic.occupazioneBySituazioneAndSettore[
                    `${this.props.findomestic.dati.situazione_lavorativa}_${this.props.findomestic.dati.settore}`
                  ]
                }
              />
            ) : null}

            {showProfessionistiRischio(this.props.findomestic) ? (
              <BuySelectInput2
                dataCy={'dataform-job-sector'}
                defaultValue={Number(
                  this.props.findomestic.dati.settore_rischio_aml
                )}
                label={'Settore attività (per AML)'}
                liClassName={`${this.state.dati_findomestic_settore_rischio_aml_error} wide`}
                placeholder={'Seleziona il Settore'}
                update={this.handleSelect(
                  'settore_rischio_aml',
                  this.props.findomesticUpdateDati
                )}
                values={getSettoriPerProfessionistiARischio(
                  this.props.findomestic
                ).map(_ => ({ label: _.descrizione, value: _.id }))}
              />
            ) : null}

            {showDataInizioAttivita(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_data_inizio_attivita_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  dataCy={'dataform-job-start-date'}
                  defaultValue={
                    this.props.findomestic.dati.data_inizio_attivita.raw || ''
                  }
                  label={'Data inizio attività (mm/aaaa)'}
                  mask="99/9999"
                  placeholder={'00/0000'}
                  type={'text'}
                  update={this.handleInput(
                    'data_inizio_attivita',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showDataScadenzaContratto(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_data_scadenza_contratto_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  dataCy={'dataform-job-end-date'}
                  defaultValue={
                    this.props.findomestic.dati.data_scadenza_contratto.raw ||
                    ''
                  }
                  label={'Data scadenza contratto (mm/aaaa)'}
                  mask="99/9999"
                  placeholder={'00/0000'}
                  type={'text'}
                  update={this.handleInput(
                    'data_scadenza_contratto',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showSedeLavoro(this.props.findomestic) ? (
              <li className="wide form-title ">
                <label>Sede di lavoro</label>
              </li>
            ) : null}
            {showSedeLavoro(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_datore_lavoro_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big capitalize"
                  dataCy={'dataform-job-employer'}
                  defaultValue={this.props.findomestic.dati.datore_lavoro}
                  label={'Denominazione società'}
                  placeholder={'Scrivi la Denominazione società'}
                  type={'text'}
                  update={this.handleInput(
                    'datore_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showSedeLavoro(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_telefono_fisso_lavoro_error} wide`}
              >
                <PhoneInput
                  className="input-data"
                  dataCy={'dataform-job-phone'}
                  label="Telefono fisso lavoro (facoltativo)"
                  name={'telefono_fisso_lavoro'}
                  onChange={this.handleInput(
                    'telefono_fisso_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                  placeholder={'Scrivi il Numero di telefono'}
                  value={this.props.findomestic.dati.telefono_fisso_lavoro}
                />
              </li>
            ) : null}

            {showSedeLavoro(this.props.findomestic) ? (
              <BuySelectInput2
                async
                dataCy={'dataform-job-town'}
                defaultOptions
                defaultValue={this.props.findomestic.dati.comune_lavoro}
                label={'Comune di lavoro'}
                liClassName={`${this.state.dati_findomestic_comune_lavoro_error} two-t`}
                loadOptions={searchQuery => {
                  const c = this.props.findomestic.dati.comune_lavoro
                    ? this.props.findomestic.dati.comune_lavoro.split('|')[0]
                    : ''
                  const sq = searchQuery || c
                  return this.props
                    .searchComuniV2Residenza(sq)
                    .then(json => transformComuniResidenzaV2Result(json.result))
                }}
                placeholder={'Seleziona il Comune'}
                update={this.handleSelect(
                  'comune_lavoro',
                  this.props.findomesticUpdateDati
                )}
                values={
                  this.props.comuni.searchComuneResidenza.length
                    ? this.props.comuni.searchComuneResidenza
                    : [
                        transformComuniNazioniDefaultValue(
                          this.props.findomestic.dati.comune_lavoro
                        ),
                      ].filter(_ => _)
                }
              />
            ) : null}

            {showSedeLavoro(this.props.findomestic) &&
            this.state.select_cap_lavoro ? (
              <BuySelectInput2
                clearable={false}
                dataCy={'dataform-job-cap'}
                defaultValue={customer.cap_lavoro || this.state.cap_lavoro}
                label={'Cap'}
                liClassName={`${this.state.dati_findomestic_cap_lavoro_error} three-t`}
                placeholder={'Cap'}
                update={this.handleSelect(
                  'cap_lavoro',
                  this.props.findomesticUpdateDati
                )}
                value={this.props.findomestic.dati.cap_lavoro}
                values={this.state.caps_lavoro}
              />
            ) : null}

            {showSedeLavoro(this.props.findomestic) &&
            !this.state.select_cap_lavoro ? (
              <li
                className={`${this.state.dati_findomestic_cap_lavoro_error} three-t`}
              >
                <BuyTextInput2
                  classes="input-data form-input big"
                  dataCy={'dataform-job-cap'}
                  disabled
                  label={'Cap'}
                  placeholder={'Scrivi il Cap'}
                  type={'number'}
                  update={this.handleInput(
                    'cap_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                  value={this.state.cap_lavoro}
                />
              </li>
            ) : null}

            {showSedeLavoro(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_indirizzo_lavoro_error} two-t`}
              >
                <BuyTextInput
                  classes="input-data form-input big capitalize"
                  dataCy={'dataform-job-address'}
                  defaultValue={this.props.findomestic.dati.indirizzo_lavoro}
                  label={'Indirizzo di lavoro'}
                  placeholder={"Scrivi l'indirizzo"}
                  type={'text'}
                  update={this.handleInput(
                    'indirizzo_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showSedeLavoro(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_civico_lavoro_error} three-t`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  dataCy={'dataform-job-number'}
                  defaultValue={this.props.findomestic.dati.civico_lavoro}
                  label={'Civico'}
                  placeholder={'Civico'}
                  type={'text'}
                  update={this.handleInput(
                    'civico_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showPaeseDiAttivita(this.props.findomestic.dati) &&
            this.props.comuni &&
            this.props.comuni.comune ? (
              <BuySelectInput2
                dataCy={'dataform-job-country'}
                defaultValue={
                  this.props.findomestic.dati.paese_di_attivita_principale
                }
                label="Paese di attività principale"
                liClassName={`${this.state.dati_findomestic_paese_di_attivita_principale_error} wide`}
                placeholder={'Seleziona il Paese'}
                update={this.handleSelect(
                  'paese_di_attivita_principale',
                  this.props.findomesticUpdateDati
                )}
                values={this.props.comuni.nazione.map(nazione => ({
                  ...nazione,
                  label: nazione.label.replace(/ \(EE\)/g, ''),
                }))}
              />
            ) : null}

            {showReddito(this.props.findomestic) ? (
              <li className="wide form-title you-pep">
                <label>
                  <a
                    href="#"
                    onClick={event => {
                      event.preventDefault()
                      event.stopPropagation()
                      this.setState({ show_howto_reddito_modal: true })
                    }}
                    target="_blank"
                  >
                    Come indicare correttamente il reddito
                  </a>
                </label>
              </li>
            ) : null}
            {showReddito(this.props.findomestic) ? (
              <li
                className={`${this.state.dati_findomestic_reddito_mensile_lavoro_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  dataCy={'dataform-job-income'}
                  defaultValue={
                    this.props.findomestic.dati.reddito_mensile_lavoro
                  }
                  isSymbol="input-symbol"
                  label={'Reddito mensile netto'}
                  placeholder={'Scrivi il Reddito mensile netto'}
                  theSymbol="€"
                  type={'number'}
                  update={this.handleInput(
                    'reddito_mensile_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showDatiConiuge(this.props.findomestic) ? (
              <li className="hr" />
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showSituazioneLavorativa(this.props.findomestic, true) ? (
              <BuySelectInput2
                defaultValue={
                  this.props.findomestic.dati.coniuge_situazione_lavorativa
                }
                label={'Situazione lavorativa del coniuge'}
                liClassName={`${this.state.dati_findomestic_coniuge_situazione_lavorativa_error} wide`}
                placeholder={'Seleziona la Situazione lavorativa'}
                update={this.handleSelect(
                  'coniuge_situazione_lavorativa',
                  this.props.findomesticUpdateDati
                )}
                values={this.props.findomestic.situazioneLavorativa}
              />
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showSettore(this.props.findomestic, true) ? (
              <BuySelectInput2
                defaultValue={this.props.findomestic.dati.coniuge_settore}
                label={'Settore del coniuge'}
                liClassName={`${this.state.dati_findomestic_coniuge_settore_error} wide`}
                placeholder={'Seleziona il Settore'}
                update={this.handleSelect(
                  'coniuge_settore',
                  this.props.findomesticUpdateDati
                )}
                values={
                  this.props.findomestic.settoreBySituazione[
                    this.props.findomestic.dati.coniuge_situazione_lavorativa
                  ]
                }
              />
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showOccupazione(this.props.findomestic, true) ? (
              <BuySelectInput2
                defaultValue={this.props.findomestic.dati.coniuge_occupazione}
                label={"Occupazione/Attivita' del coniuge"}
                liClassName={`${this.state.dati_findomestic_coniuge_occupazione_error} wide`}
                placeholder={"Seleziona l'Occupazione/Attività"}
                update={this.handleSelect(
                  'coniuge_occupazione',
                  this.props.findomesticUpdateDati
                )}
                values={
                  this.props.findomestic.occupazioneBySituazioneAndSettore[
                    `${this.props.findomestic.dati.coniuge_situazione_lavorativa}_${this.props.findomestic.dati.coniuge_settore}`
                  ]
                }
              />
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showProfessionistiRischio(this.props.findomestic, true) ? (
              <BuySelectInput2
                defaultValue={Number(
                  this.props.findomestic.dati.coniuge_settore_rischio_aml
                )}
                label={'Settore attività del coniuge (per AML)'}
                liClassName={`${this.state.dati_findomestic_coniuge_settore_rischio_aml_error} wide`}
                placeholder={'Seleziona il Settore'}
                update={this.handleSelect(
                  'coniuge_settore_rischio_aml',
                  this.props.findomesticUpdateDati
                )}
                values={getSettoriPerProfessionistiARischio(
                  this.props.findomestic,
                  true
                ).map(_ => ({ label: _.descrizione, value: _.id }))}
              />
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showDataInizioAttivita(this.props.findomestic, true) ? (
              <li
                className={`${this.state.dati_findomestic_coniuge_data_inizio_attivita_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  defaultValue={
                    this.props.findomestic.dati.coniuge_data_inizio_attivita
                      .raw || ''
                  }
                  label={"Data inizio attivita' (mm/aaaa) del coniuge"}
                  mask="99/9999"
                  placeholder={'00/0000'}
                  type={'text'}
                  update={this.handleInput(
                    'coniuge_data_inizio_attivita',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showDataScadenzaContratto(this.props.findomestic, true) ? (
              <li
                className={`${this.state.dati_findomestic_coniuge_data_scadenza_contratto_error} wide`}
              >
                <BuyDateInput
                  classes="form-input big"
                  defaultValue={
                    this.props.findomestic.dati.coniuge_data_scadenza_contratto
                      .raw || ''
                  }
                  label={'Data scadenza contratto (mm/aaaa) del coniuge'}
                  mask="99/9999"
                  placeholder={'00/0000'}
                  type={'text'}
                  update={this.handleInput(
                    'coniuge_data_scadenza_contratto',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}

            {showDatiConiuge(this.props.findomestic) &&
            showReddito(this.props.findomestic, true) ? (
              <li
                className={`${this.state.dati_findomestic_coniuge_reddito_mensile_lavoro_error} wide`}
              >
                <BuyTextInput
                  classes="input-data form-input big"
                  defaultValue={
                    this.props.findomestic.dati.coniuge_reddito_mensile_lavoro
                  }
                  isSymbol="input-symbol"
                  label={'Reddito mensile netto del coniuge'}
                  placeholder={'Scrivi il Reddito mensile netto'}
                  theSymbol="€"
                  type={'text'}
                  update={this.handleInput(
                    'coniuge_reddito_mensile_lavoro',
                    this.props.findomesticUpdateDati
                  )}
                />
              </li>
            ) : null}
          </BuyDataForm>

          <BuyDataForm
            active={this.state.section === 3}
            icon="work"
            id={'conto_corrente'}
            liWideClass={'no-margin'}
            name="section-4"
            title="Conto Corrente"
            titleClass={'no-margin no-padding'}
          >
            <li className={`wide`}>
              <p>
                Inserisci l'IBAN sul quale desideri vengano addebitate le rate
                del finanziamento che stai richiedendo
              </p>
            </li>
            <li
              className={`${this.state.dati_findomestic_data_apertura_conto_error} wide`}
            >
              <BuyDateInput
                classes="form-input big"
                dataCy={'dataform-account-date'}
                defaultValue={
                  this.props.findomestic.dati.data_apertura_conto.raw || ''
                }
                label={'Data di apertura del conto (mm/aaaa)'}
                mask="99/9999"
                placeholder={'00/0000'}
                type={'text'}
                update={this.handleInput(
                  'data_apertura_conto',
                  this.props.findomesticUpdateDati
                )}
              />
            </li>

            <li className={`${this.state.dati_findomestic_iban_error} wide`}>
              <div className="relative-input">
                <BuyTextInput
                  classes="input-data form-input big uppercase"
                  dataCy={'dataform-account-iban'}
                  defaultValue={this.props.findomestic.dati.iban}
                  label={'IBAN'}
                  placeholder={"Scrivi il l'IBAN"}
                  type={'text'}
                  update={this.handleInput(
                    'iban',
                    this.props.findomesticUpdateDati
                  )}
                />
                <div className="extra-tip">
                  <i className={'icon-info'} />
                  <span className="extra-tip-label">
                    I tuoi dati sono al sicuro: usiamo server criptati,
                    certificati SSL (Secure Sockets Layer), che garantiscono la
                    protezione dei dati sensibili.
                  </span>
                </div>
              </div>
            </li>
          </BuyDataForm>

          <BuyDataForm
            active={this.state.section === 3}
            icon="work"
            id={'privacy'}
            name="section-5"
            title="Privacy"
          >
            <li className={'wide no-margin'}>
              <label>
                Trattamento dei dati personali Findomestic Banca S.p.A.
              </label>
              <div className="informativa brumbrum-link">
                <p>
                  Ho preso visione dell'
                  <a
                    href={findomesticPrivacyHref}
                    rel="noreferrer"
                    target="_blank"
                  >
                    informativa sulla privacy Findomestic
                  </a>{' '}
                  ed in merito al trattamento dei miei dati per le seguenti
                  finalit&agrave;:
                </p>
              </div>
            </li>
            <li
              className={`${this.state.dati_findomestic_flagQualita_error} wide`}
              id={'flagQualita'}
            >
              <label className="r-checkbox long" data-cy="dataform-privacy-1">
                <input
                  checked={
                    this.props.findomestic.dati.flagQualita === '1' ||
                    this.props.findomestic.dati.flagQualita === 1
                  }
                  name="flagQualita"
                  onChange={this.handleCheckbox(
                    'flagQualita',
                    this.props.findomesticUpdateDati
                  )}
                  type="checkbox"
                />
                <span className="check"></span>
                1) profilazione avanzata per finalit&agrave; di marketing su
                &nbsp;dati acquisiti direttamente dal cliente e/o da terzi
              </label>
            </li>
            <li
              className={`${this.state.dati_findomestic_flagPromozioni_error} wide`}
              id={'flagPromozioni'}
            >
              <label className="r-checkbox long" data-cy="dataform-privacy-2">
                <input
                  checked={
                    this.props.findomestic.dati.flagPromozioni === '1' ||
                    this.props.findomestic.dati.flagPromozioni === 1
                  }
                  name="flagPromozioni"
                  onChange={this.handleCheckbox(
                    'flagPromozioni',
                    this.props.findomesticUpdateDati
                  )}
                  type="checkbox"
                />
                <span className="check"></span>
                2) ricerche di mercato, informazione, promozione e comunicazione
                &nbsp;commerciale con modalit&agrave; automatizzate, su prodotti
                e &nbsp;servizi propri e di terzi
              </label>
            </li>
            <li
              className={`${this.state.dati_findomestic_flagSocietaTerze_error} wide`}
              id={'flagSocietaTerze'}
            >
              <label className="r-checkbox long" data-cy="dataform-privacy-3">
                <input
                  checked={
                    this.props.findomestic.dati.flagSocietaTerze === '1' ||
                    this.props.findomestic.dati.flagSocietaTerze === 1
                  }
                  name="flagSocietaTerze"
                  onChange={this.handleCheckbox(
                    'flagSocietaTerze',
                    this.props.findomesticUpdateDati
                  )}
                  type="checkbox"
                />
                <span className="check"></span>
                3) comunicazione o cessione dei dati a terzi a fini di
                informazione, &nbsp;promozione e comunicazione commerciale con
                modalit&agrave; tradizionali e &nbsp;automatizzate, di loro
                prodotti e servizi
              </label>
            </li>

            <li className="hr" />

            <li className={'wide'}>
              <label>Condizioni brumbrum</label>
            </li>

            <li
              className={`${this.state.dati_cliente_condizioni_brumbrum_obbligatorie_error} wide`}
            >
              <label
                className="r-checkbox long"
                data-cy="dataform-general-conditions"
              >
                <input
                  defaultChecked={
                    this.props.customer.condizioni_brumbrum_obbligatorie ===
                      '1' ||
                    this.props.customer.condizioni_brumbrum_obbligatorie ===
                      1 ||
                    this.props.customer.condizioni_brumbrum_obbligatorie ===
                      true
                  }
                  name="condizioni_brumbrum_obbligatorie"
                  onChange={this.handleCheckbox(
                    'condizioni_brumbrum_obbligatorie'
                  )}
                  type="checkbox"
                />
                <span className="check"></span>
                Ho preso visione e accetto le{' '}
                <a
                  href={mapfreCondizioniGeneraliContratto}
                  rel="noreferrer"
                  target="_blank"
                >
                  Condizioni Generali di Contratto
                </a>{' '}
                del sito web brumbrum.it
              </label>
            </li>

            {haGaranzia3Anni(this.props.garanzia) ? (
              <li
                className={`${this.state.dati_cliente_informativa_trattamento_dati_personali_garanzia_error} wide`}
              >
                <label className="r-checkbox long">
                  <input
                    defaultChecked={
                      customer.informativa_trattamento_dati_personali_garanzia ===
                        1 ||
                      customer.informativa_trattamento_dati_personali_garanzia ===
                        '1'
                    }
                    name="informativa_trattamento_dati_personali_garanzia"
                    onChange={this.handleCheckbox(
                      'informativa_trattamento_dati_personali_garanzia'
                    )}
                    type="checkbox"
                  />
                  <span className="check"></span>
                  Ho preso visione e accetto il{' '}
                  <a
                    href={mapfreProgrammaGaranzia}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Programma di Garanzia Convenzionale
                  </a>
                  , il{' '}
                  <a
                    href={mapfreAssistenzaStradale}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Programma di Assistenza Stradale
                  </a>{' '}
                  e l'
                  <a
                    href={mapfreInformativaDatiPersonali}
                    rel="noreferrer"
                    target="_blank"
                  >
                    Informativa sul trattamento dei dati personali
                  </a>{' '}
                  del gestore del programma di garanzia
                </label>
              </li>
            ) : null}
            <li className="wide buttons">
              <a
                className={`btn btn-primary js-next-step ${
                  this.props.fetching ? ' btn-disabled' : ''
                }`}
                data-cy="dataform-submit-end"
                onClick={this.handleNext('privacy')}
              >
                <span>Prosegui</span>
              </a>
            </li>
            <li className="wide buttons">
              <a
                className="btn btn-back js-back-step"
                onClick={this.handlePrev}
              >
                Indietro
              </a>
            </li>
          </BuyDataForm>

          <DocumentiHelperModal
            display={this.state.show_condizioni_generali_di_contratto_modal}
            iframeSrc={`${window.location.origin}/condizioni-contratto/v2?embed=1&v=no-tgm|no-newrelic|no-stripe|no-optimize|no-clickstream`}
            modalTitle="Condizioni Generali di Contratto"
            onClose={() => {
              this.setState({
                show_condizioni_generali_di_contratto_modal: false,
              })
            }}
          />

          <BuyBigModal
            display={this.state.show_howto_reddito_modal}
            extraStyle={{ height: 'auto' }}
            h4="Come indicare correttamente il reddito"
            onClose={() => this.setState({ show_howto_reddito_modal: false })}
          >
            <div className={'legals__content'}>
              <p>
                <b>PER DIPENDENTI</b>
                <br />
                Indicare il netto mensile presente in busta paga escludendo
                bonus e rimborsi spese
              </p>
              <p>
                <b>PER PENSIONATI</b>
                <br />
                Indicare il netto mensile presente nel cedolino di pensione
              </p>
              <p>
                <b>PER AUTONOMI/LIBERI PROFESSIONISTI/ALTRO</b>
                <br />
                Consultare il "modello unico - persone fisiche" ed effettuare il
                calcolo delle seguenti voci:
                <br />
                [RN4 - RN26] / 12
              </p>
              <p>
                <b>oppure se in regime agevolato:</b>
                <br />
                [LM36 - LM39] / 12
              </p>
            </div>
          </BuyBigModal>
        </form>
      </div>
    )
  }
}

BuyDataFormFindomestic.propTypes = {
  customer: PropTypes.object,
  customerUpdate: PropTypes.func,
  compass_tabelledominio: PropTypes.object,
  comuni: PropTypes.object,
  fetching: PropTypes.bool,
  getComuniNazioniV1: PropTypes.func,
  findomesticUpdateDati: PropTypes.func,
  findomestic: PropTypes.object,
  findomesticTabelleDominio: PropTypes.func,
  ordine: PropTypes.object,
  phaseChange: PropTypes.func,
  putClientiV1: PropTypes.func,
  postFindomesticDatiClienteV1: PropTypes.func,
  product: PropTypes.object,
  reroute: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  ui: PropTypes.object,
  financements: PropTypes.object,
}

const mapStateToProps = state => ({
  comuni: state.comuni,
  customer: state.customer,
  fetching: state.ui.fetching,
  logistica: state.logistica,
  findomestic: state.findomestic,
  compass_tabelledominio: state.compass_tabelledominio,
  ordine: state.ordine,
  product: state.product,
  ui: state.ui,
  financements: state.financements,
  error: state.error,
  garanzia: state.garanzia,
})

const mapDispatchToProps = dispatch => ({
  customerUpdate: payload => dispatch(customerUpdate(payload)),
  getComuniNazioniV1: () => dispatch(getComuniNazioniV1),
  findomesticTabelleDominio: () => dispatch(findomesticTabelleDominio),
  findomesticUpdateDati: payload => dispatch(findomesticUpdateDati(payload)),
  phaseChange: phase => dispatch(phaseChange(phase)),
  postFindomesticDatiClienteV1: () => dispatch(postFindomesticDatiClienteV1),
  putClientiV1: () => dispatch(putClientiV1),
  reroute: payload => dispatch(reroute(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  searchComuniV2LuogoNascita: searchQuery =>
    dispatch(searchComuniV2LuogoNascita(searchQuery)),
  searchComuniV2LicenseEmission: searchQuery =>
    dispatch(searchComuniV2LicenseEmission(searchQuery)),
  searchComuniV2IdentityCardEmission: searchQuery =>
    dispatch(searchComuniV2IdentityCardEmission(searchQuery)),
  searchComuniV2PassportEmission: searchQuery =>
    dispatch(searchComuniV2PassportEmission(searchQuery)),
  searchComuniV2Cittadinanza: searchQuery =>
    dispatch(searchComuniV2Cittadinanza(searchQuery)),
  searchComuniV2Residenza: searchQuery =>
    dispatch(searchComuniV2Residenza(searchQuery)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BuyDataFormFindomestic)
